import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVurveyLabsLockupBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1328,
	height: 200,
	viewBox: "0 0 1328 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1303.73 77.7583C1302.46 63.5493 1290.59 58.2475 1279.56 58.2475C1269.17 58.2475 1258.78 64.1855 1258.78 73.5168C1258.78 81.9997 1267.26 86.8774 1276.8 89.2102L1291.22 92.8155C1307.76 96.8449 1324.52 104.692 1324.52 122.93C1324.52 146.258 1300.13 156.862 1281.04 156.862C1262.59 156.862 1238.42 148.379 1236.51 121.233H1255.59C1258.14 135.23 1266.83 140.744 1281.68 140.744C1292.49 140.744 1305.43 136.927 1305.43 124.202C1305.43 114.871 1296.31 111.69 1285.92 109.145L1270.65 105.328C1254.32 101.298 1239.69 91.331 1239.69 74.3651C1239.69 53.7939 1260.9 42.1299 1280.19 42.1299C1301.61 42.1299 1320.49 53.5819 1322.61 77.7583H1303.73Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1177.21 42.1321C1208.17 42.1321 1227.26 65.2481 1227.26 99.1799C1227.26 133.112 1208.17 156.864 1177.21 156.864C1157.28 156.864 1143.49 143.715 1139.46 132.475H1139.25V154.319H1120.16V2.89844H1139.25V66.9447H1139.46C1143.49 55.4927 1157.28 42.1321 1177.21 42.1321ZM1138.61 99.1799C1138.61 120.811 1149.64 140.534 1173.39 140.534C1196.51 140.534 1208.17 122.932 1208.17 99.1799C1208.17 75.4276 1195.87 58.2497 1173.39 58.2497C1149.64 58.2497 1138.61 77.7604 1138.61 99.1799Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1011.72 77.7623C1014.05 61.8568 1027.41 41.9219 1056.04 41.9219C1096.34 41.9219 1100.16 68.0069 1100.16 84.9728V132.053C1100.16 140.324 1101 149.019 1101.85 154.321H1081.49C1081.07 149.019 1081.07 144.566 1081.07 138.415V134.174H1080.86C1078.31 142.657 1069.19 156.866 1044.8 156.866C1018.51 156.866 1006.42 140.112 1006.42 124.419C1006.42 93.4558 1045.44 92.3954 1061.98 89.4264C1076.4 86.8815 1081.07 82.8521 1081.07 73.7329C1081.07 64.6138 1072.37 58.0395 1056.68 58.0395C1043.32 58.0395 1033.35 65.8862 1030.81 77.7623H1011.72ZM1025.29 124.419C1025.29 134.81 1034.84 141.384 1048.2 141.384C1064.95 141.384 1081.49 130.569 1081.49 103.423L1081.28 88.1539C1079.16 95.3644 1074.5 101.727 1050.74 105.968C1034.84 108.725 1025.29 113.391 1025.29 124.419Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M757.46 44.6758L792.24 135.443H792.452L823.627 44.6758H843.986L794.36 175.525C789.483 188.674 781.424 196.733 766.579 196.733H751.734V180.615H763.822C774.426 180.615 776.122 174.677 779.303 166.83L783.121 157.287C767.851 119.75 752.37 82.2128 737.101 44.6758H757.46Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M733.783 121.657C727.633 144.986 709.183 156.862 684.794 156.862C652.347 156.862 630.928 133.322 630.928 98.9656C630.928 65.8821 653.408 42.1299 684.37 42.1299C722.968 42.1299 735.056 73.0926 735.48 101.298V104.692H649.378C650.863 127.596 664.86 140.956 684.37 140.956C699.003 140.956 711.304 135.23 715.121 121.657H733.783ZM649.59 89.4223H716.181C714.485 70.3357 703.881 57.8233 684.37 57.8233C664.647 57.8233 652.135 70.5477 649.59 89.4223Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M548.007 44.6758C558.398 74.7902 568.578 104.905 578.97 135.019H579.182L609.72 44.6758H630.503C616.719 81.1524 603.146 117.841 589.361 154.318H568.366C554.581 117.841 541.008 81.1524 527.224 44.6758H548.007Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M485.469 44.6761V66.7318C490.983 50.6142 501.587 44.252 518.129 44.252V62.4903C517.28 62.4903 513.887 62.7024 511.13 63.1265C498.406 65.0352 485.469 70.7612 485.469 102.572V154.318H466.383V44.6761H485.469Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M355.619 115.72V44.6758H374.706V113.812C374.706 133.11 382.977 140.745 397.822 140.745C413.939 140.745 428.148 127.172 428.148 98.5425V44.6758H447.235V154.318H428.148V133.747C422.422 146.259 412.243 156.863 395.277 156.863C366.435 156.863 355.619 137.988 355.619 115.72Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219.469 2.89844H241.525L286.06 133.748H286.909L331.868 2.89844H353.924L299.209 154.107L273.76 154.319L219.469 2.89844Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M922.68 2.89844H902.533V127.609H922.68V2.89844Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M929.153 137.353V154.319H996.269V137.353H929.153Z",
			fill: "#1A1A1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.7168 2.7168H138.226V62.9432L47.8866 153.283V108.113H2.7168V2.7168ZM62.8931 17.7458H17.7059V62.933H62.8931V17.7458Z",
			fill: "#1A1A1A"
		})
	]
});
export default SvgVurveyLabsLockupBlack;
